import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { getByIdPA, sendUpdateLicense } from '../../context/users/UserActions'
import { useUserContext } from '../../context/users/UserContext'

// eslint-disable-next-line
export default function (props) {
  const EMAIL_REGEX = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/
  const navigate = useNavigate()
  const { user: license, setUser, authenticatedUser, setAlert } = useUserContext()
  const params = useParams()

  const [email, setEmail] = useState('')
  const [validEmail, setValidEmail] = useState(true)

  const handleChangeEmail = (e) => {
    setEmail(e.target.value)
    if(e.target.value === '') {
      setValidEmail(true)
    } else {
      setValidEmail(EMAIL_REGEX.test(e.target.value))
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if(!validEmail) {
      setAlert({
        message: 'Por favor ingresa el correo electrónico con formato válido.',
        msgType: 'warning'
      })
    } else {
      let record = await sendUpdateLicense({
        userId: license.userId,
        data: {
          email,
        },
        token: authenticatedUser.value
      })

      if(Object.prototype.hasOwnProperty.call(record, 'message')) {
        navigate(`/licencias`)
      } else {
        setAlert({
          message: record.message,
          msgType: 'warning'
        })
      }
    }
  }

  const fetchData = async () => {
    const membership = await getByIdPA({ path: 'memberships', id: params.id, token: authenticatedUser.value })
    setEmail(membership.userEmail)
    setUser(membership)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <>
      <div className='Auth-form-container'>
        <form onSubmit={handleSubmit} className='Auth-form'>
          <div className='Auth-form-content'>
            <div className='form-group text-center'>
              <h2>Actualizar Licencia:</h2>
              <h6>{license.licenseCode}</h6>
            </div>

            {/* <h3 className='Auth-form-title'>Sign In</h3> */}
            <div className='form-group mt-3'>
              <label>Correo Asignado *</label>
              <input
                type='text'
                className='form-control mt-1'
                placeholder='Correo Asignado'
                value={email}
                onChange={handleChangeEmail}
              />
            </div>
            {!validEmail && (
              <label className='mt-2 text-lg text-danger'>Correo con formato inválido</label>
            )}

            <div className='d-grid gap-2 mt-5'>
              <button type='submit' className='btn btn-primary btn-block mb-3'>
                ACTUALIZAR
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
